(() => {
  const forms = document.querySelectorAll('.goat-home-sample__form, .goat-contact-page__form');

  if (!forms.length) {
    return;
  }

  const getField = (form, name) => form.querySelector(`[data-goat-sample-field="${name}"]`);
  const getValue = (form, name) => getField(form, name)?.value?.trim() || '';
  const isSampleRequest = (form) => {
    const requestType = getValue(form, 'requestType');

    return !requestType || requestType === 'sample';
  };
  const syncSampleFields = (form) => {
    const sampleRequest = isSampleRequest(form);

    form.dataset.goatSampleMode = sampleRequest ? 'sample' : 'message';
    form.querySelectorAll('[data-goat-sample-required-group]').forEach((group) => {
      group.hidden = !sampleRequest;
    });
    form.querySelectorAll('[data-goat-sample-required]').forEach((field) => {
      field.required = sampleRequest;
      field.setAttribute('aria-required', sampleRequest ? 'true' : 'false');
    });
    form.querySelectorAll('[data-goat-message-required]').forEach((field) => {
      field.required = !sampleRequest;
      field.setAttribute('aria-required', sampleRequest ? 'false' : 'true');
    });
  };

  const setStatus = (form, type, message) => {
    const wrapper = form.closest('[data-goat-sample-order-endpoint]');
    const success = wrapper?.querySelector('[data-goat-sample-order-success]');
    const error = wrapper?.querySelector('[data-goat-sample-order-error]');
    const submitButton = form.querySelector('[data-goat-sample-submit]');

    if (success) {
      success.hidden = type !== 'success';
      const messageNode = success.querySelector('[data-goat-sample-order-success-message]');

      if (messageNode && message) {
        messageNode.textContent = message;
      }
    }

    if (error) {
      error.hidden = type !== 'error';
      error.textContent = type === 'error' ? message : '';
    }

    if (submitButton) {
      submitButton.hidden = type === 'success';
    }
  };

  const getPayload = (form) => ({
    email: getValue(form, 'email'),
    name: getValue(form, 'name'),
    facility: getValue(form, 'facility'),
    phone: getValue(form, 'phone'),
    address1: getValue(form, 'address1'),
    address2: getValue(form, 'address2'),
    city: getValue(form, 'city'),
    province: getValue(form, 'province'),
    zip: getValue(form, 'zip'),
    country: getValue(form, 'country'),
    notes: getValue(form, 'notes'),
    website: getValue(form, 'website'),
    sourceUrl: window.location.href
  });

  const getEndpoint = (form) => form.closest('[data-goat-sample-order-endpoint]')?.dataset.goatSampleOrderEndpoint?.trim() || '';

  forms.forEach((form) => {
    if (form.dataset.goatSampleOrderReady === 'true') {
      return;
    }

    form.dataset.goatSampleOrderReady = 'true';
    syncSampleFields(form);
    getField(form, 'requestType')?.addEventListener('change', () => {
      syncSampleFields(form);
      setStatus(form, '', '');
    });

    form.addEventListener('submit', async (event) => {
      const endpoint = getEndpoint(form);

      if (!endpoint || !isSampleRequest(form)) {
        return;
      }

      event.preventDefault();
      setStatus(form, '', '');

      const submitButton = form.querySelector('[data-goat-sample-submit]');
      const previousLabel = submitButton?.textContent;

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Sending request...';
      }

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(getPayload(form))
        });
        const result = await response.json().catch(() => ({}));

        if (!response.ok || !result.ok) {
          throw new Error(result.error || 'We could not send the sample request.');
        }

        form.reset();
        syncSampleFields(form);
        setStatus(form, 'success', 'Thanks. Your sample request is in our fulfillment queue.');
        document.dispatchEvent(new CustomEvent('goat:sample-request-success', {
          detail: {
            order_id: result.orderId,
            order_name: result.orderName
          }
        }));
      } catch (error) {
        setStatus(form, 'error', error instanceof Error ? error.message : 'We could not send the sample request.');
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = previousLabel || 'Send sample request';
        }
      }
    });
  });
})();
